module.exports = __webpack_public_path__ + "media/images/icons/crosshairs-50c931f8ddbf658732272ebe678570c4.svg";